export default __webpack_public_path__ + "static/media/contact_mail.258e97eb.svg";